function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import Error from "next/error";
import AiGeneratedTemplate from "components/templates/ai-generated-template/ai-generated-template";
import BaseTemplatePage, { getServerSideProps as getBaseProps } from "./base-template-page";
const { buildAiGeneratedPageProps } = require("services/ai-generated-page-props");
// SSR entry for AI-generated (/gp/) pages. Reuses base-template-page's getServerSideProps so we get
// translations, localized header/footer catalog links, and AB-test context for free, then adds the
// AI page's body content (extracted from the stored document) so the template can render it between
// the real React header and footer.
export function getServerSideProps(context) {
    return _getServerSideProps.apply(this, arguments);
}
function _getServerSideProps() {
    _getServerSideProps = _async_to_generator(function*(context) {
        const baseProps = yield getBaseProps(context);
        if (baseProps.props.errorCode) return baseProps;
        // Server-only requires — used solely here, so Next keeps them out of the client bundle.
        const { injectTrackingScripts, getExactAbTest } = require("server/controllers/generated/tracking-scripts");
        const { HEAD_SCRIPTS, BODY_SCRIPTS } = require("services/generated-pages-bundle-service");
        const props = yield buildAiGeneratedPageProps({
            baseProps: baseProps.props,
            pageConfig: baseProps.props.pageConfig,
            context,
            deps: {
                injectTrackingScripts,
                getExactAbTest,
                HEAD_SCRIPTS,
                BODY_SCRIPTS,
                baseUrl: process.env.MONDAY_BASE_PATH
            }
        });
        // Drop the raw document from the client payload — we ship the extracted body instead.
        return {
            props
        };
    });
    return _getServerSideProps.apply(this, arguments);
}
class AiGeneratedPage extends BaseTemplatePage {
    render() {
        const { errorCode } = this.props;
        if (errorCode) return /*#__PURE__*/ _jsx(Error, {
            statusCode: errorCode
        });
        return /*#__PURE__*/ _jsx(AiGeneratedTemplate, _object_spread({}, this.props));
    }
}
export { AiGeneratedPage as default };
